export interface IResponseBase {
    Success: boolean,
    ErrorMessage: string,
    StackTrace: string
}

export interface IQuickNavInfoResponse extends IResponseBase {
    SearchInfoList: IQuickNavSearchTypeAndInfo[],
    MappingList: IQuickNavResultTypeToUrl[]
}

export interface IQuickNavResultTypeToUrl {
    ResultType: string,
    Url: string
}

export interface IQuickNavSearchTypeAndInfo {
    SearchType: eSearchType,
    SearchInfo: IClientSideSearchInfo
}

export interface IClientSideSearchInfo {
    SearchServiceUrl : string,
    SearchIndexName : string,
    SearchApiKey : string,
    SearchFields : string,
    HighlightFields : string,
    SelectFields : string,
    Facets : string[],
    Filter : string,
    ScoringProfile : string,
    OrderBy : string,
    SearchKeywords: ISearchKeyword[],
    NumericOnlyFields: string
}

export interface ISearchKeyword {
    Keyword: string,
    SearchColumns: string[]
}

export enum eSearchType {
    Person = 1,
    Witness_Person = 2,
    Codefendant = 4,
    Navbar = 8,
    Witness_Officer = 16,
    Witness = 32 
}

export interface IGetQuickSearchRequestPayload {
    search: string,
    searchMode: string,
    count: boolean,
    skip?: number,
    top?: number,
    highlight?: string,
    select?: string,
    highlightPreTag?: string,
    highlightPostTag?: string,
    searchFields?: string,
    facets?: string[],
    filter?: string
    queryType?: string,
    scoringProfile?: string,
    orderby?: string,
    minimumCoverage: number
}

export interface IGetNavLinkResponseModel {
    civilcase?: string,
    civildoc?: string,
    civilparty?: string,
    crimcase?: string,
    crimdoc?: string,
    crimparty?: string,
    person?: string,
    persondoc?: string,
    officer?: string
}

// export interface IQuickSearchItem {
//     Name?: string,
//     PersonName?: string,
//     DOB?: string,
//     SSN?: string,
//     FileNo?: string,
//     Court?: string,
//     Report?: string,
//     LeadCharge?: string,
//     Matter?: string,
//     CivilMatter?: string,
//     DocName?: string,
//     //CategoryType: QuickSearchCategory,
//     AliasPerson?: string | string[],
//     TicketNumber?: string | string[],
//     LegacyFileNumber?: string,
//     OCN?: string,
//     Agency?: string,
//     PhoneNumber?: string | string[],
//     ArrestNumber?: string,
//     DSN?: string,
//     DLNumber?: string | string[],
//     DocComment?: string,
//     PersonNumber?: string,
//     BlobStorageId?: string,
//     URL?: string,
//     CivilDescription?: string,
//     VictimWitnessName?: string,
//     JuvenileFlag?: boolean,
//     PersonInvolvement?: string,
//     Content?: string[],
//     ResultType?: string,
//     Rank?: string,
//     BadgeNumber?: string,
//     TerminationDate?: string,
//     AgencyCode?: string,
//     BlobModifiedDate?: string,

//     // QuickNav fields added 2025-06-30
//     Employer?: string,
//     CaseNotes?: string | string[],
//     PersonNotes?: string | string[],
//     EvidenceNotes?: string | string[],
//     EvidenceDescription?: string | string[],
//     SentenceNotes?: string | string[],
//     Address?: string | string[],
//     AdditionalAddress?: string | string[],
//     AdditionalAddressDescription?: string | string[],
//     LabNumber?: string | string[],
//     LabNotes?: string | string[];
//     InvestigatorNotes?: string | string[];
//     InvestigatorServicesNotes?: string | string[];
//     TimeEntryDescription?: string | string[];
//     CreateDate?:string,
//     CreateUserId?: string,
//     UpdateUserId?:string,
//     DocumentCategory?:string
// }

/**
 * Interface for GetQuickSearchResult API Response
 */
export interface IQuickSearchPBKNote {
    Notes?: string,
    UpdateDate?: string,
    UpdateUserId?: string
}

export interface IQuickSearchAdditionalAddress {
    Description?: string,
    FullAddress?: string,
    AddressLine1?: string,
    AddressLine2?: string,
    City?: string,
    State?: string,
    ZipCode?: string
}

export interface IQuickSearchResidesWith {
    resideswithperson?: number,
    lastname?: string,
    firstname?: string,
    middlename?: string,
    lastfirstname?: string
}

export interface IQuickSearchLabNumber {
    LabNumber?: string,
    LabNumberPartial?: string,
    Date?: string,
    LabType?: string,
    LabTypeDescription?: string,
    LabLocation?: string,
    LabLocationDescription?: string,
    LabResults?: string,
    LabResultsDescription?: string,
    LabNotes?: string
}

export interface IQuickSearchInvestigatorService {
    Investigator?: string,
    UserName?: string,
    ServiceDate?: string,
    ServiceCode?: string,
    ServiceCodeDescription?: string,
    ServiceNotes?: string
}

export interface IQuickSearchTimeEntry {
    ActionDate?: string,
    HoursExpended?: number,
    ActivityDescription?: string,
    InvoiceCategoryDescription?: string,
    TimeDescription?: string
}

export interface IQuickSearchEnhancementBase {
    EnhancementCode?: string,
    EnhSeq?: string,
    EnhStatute?: string,
    EnhDescription?: string
}

export interface IQuickSearchEnhancementWithDispo extends IQuickSearchEnhancementBase {
    DispositionCode?: string,
    DispositionDate?: string
}

export interface IQuickSearchCharge {
    CountNumber?: number,
    Statute?: string,
    ChargeDescription?: string,
    Severity?: string,
    ChargeModifier?: string,
    OffenseFromDate?: string,
    ReferralStatute?: string,
    ReferralChargeDescription?: string,
    ReferralSeverity?: string,
    ReferralModifier?: string,
    DispositionCode?: string,
    DispositionDate?: string,
    SentenceDate?: string,
    SentenceNotes?: string,
    enhancements?: IQuickSearchEnhancementWithDispo[],
    leenhancements?: IQuickSearchEnhancementBase[]
}

export interface IQuickSearchEvidence {
    CatalogNumber?: string,
    CatalogDate?: string,
    LemsId?: string,
    Location?: string,
    LocationDescription?: string,
    Evidence_description?: string,
    RoomCode?: string,
    DisposalReason?: string,
    DisposalReasonDescription?: string,
    Notes_searchable?: string,
    PdNumber?: string,
    PdName?: string,
    DiscoveredDate?: string
}

export interface IQuickSearchResponseItem {
    '@search.score': number,
    '@search.highlights'?: any,
    name?: string,
    name_sortable?: string,
    filenumber?: string,
    personnumber?: string,
    personnumber_filterable?: string,
    resulttitle?: string,
    resulttype?: string,
    lastfirstname?: string,
    aliaslastfirstname?: string[],
    firstlacourtnumberstname?: string,
    courtnumber: string[],
    reportnumber: string[],
    ticketnumber?: string[],
    legacyfilenumber?: string,
    dob?: string,
    ocn?: string,
    ocnpartial?: string,
    agency?: string,
    ssn?: string,
    phonenumber?: string[],
    arrestnumber?: string,
    civilmatter?: string,
    dsnpartial?: string,
    dlnumberpartial?: string[],
    alloweduserteams?: string[],
    disalloweduserteams?: string[],
    documentname: string,
    documentcomment: string,
    leadcharge?: string,
    civildescription?: string,
    victimwitnessname?: string,
    juvenileflag?: boolean,
    personinvolvement?: string,
    content?: string[],
    addresslistpartial?: string[],
    sidlistpartial?: string[],
    lidlistpartial?: string[],
    ssnlistpartial?: string[],
    fbiidentifierlistpartial?: string[],
    inmatenumberlistpartial?: string[],
    rank?: string;
    badgenumber?: string;
    pdnumber?: string;
    agencycode?: string;
    dsnsequence?: string;
    terminationdate?: string;
    involvementlist?: string[];
    blobmodifieddate?: string;
    blobstorageid?: string;

    // Updated fields - 2025-06-30
    employer?: string;
    personnotes?: IQuickSearchPBKNote[];
    casenotes?: IQuickSearchPBKNote[];
    additionaladdresses?: IQuickSearchAdditionalAddress[];
    resideswith?: IQuickSearchResidesWith[];
    labnumbers?: IQuickSearchLabNumber[];
    investigatorservices?: IQuickSearchInvestigatorService[];
    timeentries?: IQuickSearchTimeEntry[];
    chargelist?: IQuickSearchCharge[];
    evidence?: IQuickSearchEvidence[];
    investigatornotes?: IQuickSearchPBKNote[];
}


export interface IAzureIndexResponseFacetModel{
    count: number,
    value: string
}

export interface IAzureIndexResponseModel {
    '@odata.count': number,
    '@search.coverage': number,
    //'@search.facets'?: [],
    '@search.facets'?: { [key: string]: IAzureIndexResponseFacetModel[]},
    value: []
}

export interface QuickSearchResultModel {
  count: number;
  items: IQuickSearchResponseItem[];
  facets?: { [key: string]: IAzureIndexResponseFacetModel[] };
  searchCoverage: number;
  mappingList?: IQuickNavResultTypeToUrl[]
}


export enum CategoryAPIName {
  civilcase = 'civilcase',
  civildoc = 'civildoc',
  civilparty = 'civilparty',
  crimcase = 'crimcase',
  crimdoc = 'crimdoc',
  crimparty = 'crimparty',
  person = 'person',
  persondoc = 'persondoc',
  officer = 'officer'
}

export enum QuickSearchCategory {
    all,
    person,
    crimcase,
    civilcase,
    crimdoc,
    civildoc,
    persondoc,
    officer,
}

export const QuickSearchCategoryNameMap = new Map<number, string>([
    [QuickSearchCategory.all, 'All'],
    [QuickSearchCategory.person, 'Persons'],
    [QuickSearchCategory.crimcase, 'Criminal cases'],
    [QuickSearchCategory.civilcase, 'Civil cases'],
    [QuickSearchCategory.crimdoc, 'Criminal docs'],
    [QuickSearchCategory.civildoc, 'Civil docs'],
    [QuickSearchCategory.persondoc, 'Person docs'],
    [QuickSearchCategory.officer, 'L.E. Officers']
]);

export interface IQuickSearchItem {
    Name: string,
    PersonName?: string,
    DOB?: string,
    SSN?: string,
    FileNo?: string,
    Court?: string,
    Report?: string,
    LeadCharge?: string,
    Matter?: string,
    CivilMatter?: string,
    DocName?: string,
    CategoryType: QuickSearchCategory,
    AliasPerson?: string | string[],
    TicketNumber?: string | string[],
    LegacyFileNumber?: string,
    OCN?: string,
    Agency?: string,
    PhoneNumber?: string | string[],
    ArrestNumber?: string,
    DSN?: string,
    DLNumber?: string | string[],
    DocComment?: string,
    PersonNumber?: string,
    BlobStorageId?: string,
    URL?: string,
    CivilDescription?: string,
    VictimWitnessName?: string,
    JuvenileFlag?: boolean,
    PersonInvolvement?: string,
    Content?: string[],
    ResultType?: string,
    Rank?: string,
    BadgeNumber?: string,
    TerminationDate?: string,
    AgencyCode?: string,
    BlobModifiedDate?: string,
    Employer?: string,
    CaseNotes?: string | string[],
    PersonNotes?: string | string[],
    EvidenceNotes?: string | string[],
    EvidenceDescription?: string | string[],
    SentenceNotes?: string | string[],
    Address?: string | string[],
    AdditionalAddress?: string | string[],
    AdditionalAddressDescription?: string | string[],
    LabNumber?: string | string[],
    LabNotes?: string | string[];
    InvestigatorNotes?: string | string[];
    InvestigatorServicesNotes?: string | string[];
    TimeEntryDescription?: string | string[];
    CreateDate?:string,
    CreateUserId?: string,
    UpdateUserId?:string,
    DocumentCategory?:string
    ResultIcon:string
    Involvementlist?:string
    DsnSequence?: string
}